// Overhead
import React from 'react'
// import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import $ from 'jquery'

// Components
import GlobalBanner from '../../components/globalBanner'
import LinnerDiv from '../../components/lineDiv'
import SubHeader from '../../components/subHeader'
import Note from '../../components/note'
import GuestPPLogInMini from '../../components/guestPPMiniLogIn'
import GuestPPLogIn from '../../components/guestPPLogIn'
import GuestSubmitButton from '../../components/guest-submit-button'
import AmountWrapper from '../../components/amountWrapper'
import GuestForm from '../guest/guestForm'
import PayCreditOrDebit from '../../components/payCreditOrDebit'
import RecurringCheckBox from '../../components/recurring-checkbox'
import CancelAndReturn from '../../components/cancelAndReturn'

// App Store/Flux
import AppStore from '../../stores/AppStore';
import AppDispatcher from '../../dispatcher/AppDispatcher'
import * as DonateAppActions from '../../actions/AppActions'

// Utility
import '../../utility/csrf'
import * as amountUtils from '../../components/amount/amountUtils';
import { handleLogIn, handleTokenReuse, addShake, validateDonationAmountForUS, updateDonation, handleGuestCountryChange } from '../../utility/helper'
import * as FPT from '../../utility/fpt'
import templateData from '../../utility/getTemplateData'
import { localsMessages, guestLocalsMessages } from '../../utility/getTemplateData'
import { formatAmount } from '../../utility/formator'
import { guestPayment } from './helper'

//Portable Progressive
import * as Progressiveonboarding from '../../../../node_modules/portableonboarding/build/portableComponents'

const AppActions = Progressiveonboarding.default.exportAppActions();
const pxp = templateData.pxp || {};
const showGuestPPLogInExp = pxp.guestPayPalLogIn && pxp.guestPayPalLogIn.experiment || false;

const messages = localsMessages('common/amount');
const errorMessages = localsMessages('routes/guest');
const allGuestMessages = guestLocalsMessages();
const initialData = JSON.parse(document.getElementById('initialData').innerHTML || {});
const senderDetails = initialData.senderDetails || {};
const prefillAddress = senderDetails.address || {};
const prefillPhone = senderDetails.phone || {};

export default React.createClass({

	contextTypes: {
		router: PropTypes.object.isRequired
	},

	getInitialState() {
		return {
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			orgName: templateData.charityName,
			donationId: templateData.donationId,
			guestRedirectUrl: templateData.guestRedirectUrl,
			donateDisabled: false,
			showServiceErrors: false,
			errorMesages: [],
			recurringEnabled: templateData.recurringEnabled,
			recurringStatus: false,
			country: initialData.selectedCountry,
			selectedCountry: initialData.selectedCountry,
			charityCountry: templateData.charityCountry,
			memberMandatory: templateData.memberMandatory || false,

			recurringHelpText: '',
			recurringLabel: 'Make this a monthly donation',
			isProgressive: templateData.onboardingEnabled || false,
			isDonating: false,
			isShareAddress: false,
			shareAddress: {},
		};
	},

	componentDidMount() {
		if (this.state.isProgressive) {
			$('.spinneroverlay').show();
		}
		// Only adding page name, if "fptPageName=landing", in other cases track event will be triggered when template is loaded.
		if (templateData.fptPageName === 'landing') {
			FPT.trackPage('main:donate:wps:guest:guestform', 'main:donate:wps:guest:guestform:web::')
		}

		// Checking for recurring status
		if (AppStore.getDonationRecurring() === 'checked') {
			this.setState({ recurringStatus: true })
		}

		// Checking token status
		handleTokenReuse();

		// Handles serverside errors
		this.dispatcherMessages = AppDispatcher.register((payload) => {
			 if (payload.action && (payload.action.actionType === 'UPDATE_SERVER_ERRORS')) {
				let errorMesages = payload.action.item.serverErrors
				let showServiceErrors = errorMesages.length > 0

				this.setState({ showServiceErrors, errorMesages });

				if (showServiceErrors) {
					let errorEl = $('.service_error_holder:visible')
					$('html, body').animate({ scrollTop: errorEl.offset() && errorEl.offset().top }, 1000);
				}
			 }
		});
	},

	componentWillUnmount() {
		AppDispatcher.unregister(this.dispatcherMessages);
	},

	/**********
	Calls dispatch on progressive redux store to directly update name and address input field values
	**********/
	setInitialState(store) {
		if(store.getState().formFields.fieldState){
			store.dispatch({
	            type: 'UPDATE_WITH_PREFILL_DATA',
	            prefilledAddressInfo: {
	                paypalAccountData_address1: prefillAddress.address1 || '',
	                paypalAccountData_address2: prefillAddress.address2 || '',
	                paypalAccountData_city: prefillAddress.city || '',
	                paypalAccountData_state: prefillAddress.state || '',
	                paypalAccountData_zip: prefillAddress.zip || '',
	                paypalAccountData_firstName: senderDetails.first_name || '',
	                paypalAccountData_lastName: senderDetails.last_name || '',
	                paypalAccountData_email: senderDetails.sender_email || '',
	                paypalAccountData_phone: prefillPhone.phone_number || '',
	                paypalAccountData_memberMandatory: this.state.memberMandatory|| false
	            }
	        })
		}
		if(!store.getState().donorName) {
			store.dispatch({
				type: 'ADD_DONOR_NAME',
				donorName: templateData.charityName
			})
		}

		this.setState({ reduxStore: store, reduxStoreState: store.getState() });

        if(this.state.memberMandatory) {
                store.dispatch({
                    type: 'UPDATE_DYNAMIC_SECTION',
                    value: true
                });
                store.dispatch({
                    type: 'HIDE_RENDER_CONTROLLER',
                    value: true
                });
            }
    },

	/**********************
	Handle Country Change - Passed to Progressive component
	Gets new props for new country. If country is not allowed for a guest,
	it will redirect to legacy
	**********************/
	handleCountryChange(country) {
		let { charityCountry } = this.state;

		if (country !== initialData.selectedCountry) {
			DonateAppActions.changeCountry({ country: country });
			this.setState({ country: country });
			// Beacons for country change
			FPT.trackLinkClickWithData('changeCountry', { country: country });

			let { token, signUp = false } = templateData;
			let url = signUp ?
				`/donate?token=${token}&signup=true&country.x=${country}&locale.x=${country}` :
				`/donate?token=${token}&country.x=${country}&locale.x=${country}&clientState=/donate/guest?token=${token}`;

			this.toggleSpinner(true);
			handleGuestCountryChange(url);
		}
	},

	getFPTDATA() {
		return {
			amount: AppStore.getDonationAmount(),
			code: AppStore.getDonationCode(),
			symbol: AppStore.getDonationSymbol()
		}
	},

	updateConversionSataus(status = false) {
		this.setState({ donateDisabled: status });
	},

	handleLogIn(event) {
		event.preventDefault();

		if (AppStore.getDonationAmount()) {
			FPT.trackLinkClickWithData('guestLogIn', {
				amount: AppStore.getDonationAmount(),
				code: AppStore.getDonationCode(),
				symbol: AppStore.getDonationSymbol()
			})
		}

		// Proceed to Login only if the donation amount is valid
		if (this.validateDonationAmount()) {
			let { token } = templateData;
			handleGuestCountryChange(`/donate/member?token=${token}`);
		}
	},

	/**
	 * Display validation error
	 */
	displayValidationError() {
		const errorMessage = amountUtils.getMinimumDonationErrorMessage(messages);
		this.setState({
			showValidationError: true,
			validationErrorMessage: errorMessage
		});
		addShake();
	},

	hideValidationError() {
		this.setState({ showValidationError: false })
	},

	/**
	 * Validates donation amount and displays the validation error if any
	 */
	validateDonationAmount() {
		if (validateDonationAmountForUS()) {
			this.setState({ showValidationError: false, validationErrorMessage: '' });
			return true;
		}
		this.displayValidationError();
		return false;
	},

	handleRecurringChange(status = false) {
		this.setState({ recurringStatus: status });
	},

	/**
	 * Clear the validation error onFocus
	 */
	handleAmountFocus() {
		if (this.state.showValidationError) {
			this.hideValidationError();
		}
	},

	/**********************
	UpdateReduxStore, passed to Progressive Component.
	Simply takes the state object from the store, and throws it in container state
	**********************/
	updateReduxStore (store) {
		const { appState: { appBusy, pageFlowData: { serviceData: { userAccountData = {} }  = {}, sessionStatus = {} } = {} } = {} } = store.getState();
		const {paypalAccountData_donateCountryselector = {}, paypalAccountData_shareAddress = {}} = store.getState().formFields.fieldState;
		const isFullUser = sessionStatus.guestAccount === 'exists';
		const isGuestUser = sessionStatus.paypalAccount === 'exists';
		const isCardAdded = userAccountData.isLoggedIn === true;

		/*
		* Need to presist value shareAddress checkbox
		* after completion of `/welcome/donate, redux store is reset and shareAddress checkbox value changes to false
		*/
		this.setState({ shareAddress: paypalAccountData_shareAddress});

		this.toggleSpinner(appBusy);

		/*
		* ERROR CASE 1:- Guest full user add card failed
		* Full user account is created successfully
		* Card additon failed
		* User is logged in
		* User will be redirected to /member
		* Member route will take care - to add new funding instrument
		*/
		if (isFullUser && !isCardAdded) {
			return this.handleMemberFailure();
		}

		/*
		* Continue with donation
		* Account is created successfully
		* Card is added
		* User is logged in or not
		*
		* In-case of guest user - if not logged in - will try to get payeeId from mayFly
		* TODO: adding middleware - to accept unautorized guest user and make final attempt to login by getting payeeId from mayFly
		*/
		if (isFullUser || isGuestUser) {
			return this.processPayment();
		}
		/*
		*  for handling the country change based on the store value change for the country dropdown.
		*
		*/

		if(paypalAccountData_donateCountryselector && this.state.country !== paypalAccountData_donateCountryselector.value) {
			/*****
			The updateReduxStore() method is called every time an action is dispatched to the

			progressive store.
			That means the condition above is checked every time an action is dispatched.

			In the ProgressiveOnboarding component, there are two dispatches fired off in
			onChange() of the country drop down select field. That means the updateReduxStore() method
			is fired twice, and this check is made twice.

			this.setState() is asynchronous. Updating our state with this.setState() was two slow, and
			there isn't a way to make this.setState() synchronous. So, to avoid
			this.handleCountryChange() being fired twice(once for each dispatch), and sending two
			/donate/update/donation requests, we set the state directly, making it synchronous, and
			change this.state.country before the next updateReduxStore() is fired. When the second one is
			fired, this.state.country will have changed, and this.handleCountryChange will not fire again.

			Because we are not relying on this.state.country to trigger a re-render, and only using it
			for a condition to ultimately redirect the page, this is an appropriate departure from
			React's way of managing state.
			*****/

			this.state.country = paypalAccountData_donateCountryselector.value;
			this.handleCountryChange(paypalAccountData_donateCountryselector.value);
		}
	},

	/*
	* showing and hiding spinner
	*/
	toggleSpinner (isSpinner = false) {
		if (this.state.isDonating) {
			return;
		}
		if (isSpinner) {
			$('.spinneroverlay').show();
		} else {
			$('.spinneroverlay').hide();
		}
	},

	/*
	* updateShareAddress
	* setting value of shareAddress checkbox before onboarding dispatched any event
	* shareAddress checkbox value is used by planning
	*/
	updateShareAddress () {
		DonateAppActions.updateShareAddress( this.state.shareAddress.value );
	},


	/*
	* triggerAccountCreation
	*/
	triggerAccountCreation (event) {
		this.updateShareAddress();
		this.state.reduxStore.dispatch(AppActions.submitFormAjax('/appData/action', 'submit_account_create', [{key: '/paypalAccountData/createUpdateReady', value: true}, {key: '/cardData/createUpdateReady', value: true}], event));
	},

	/*
	* processDonation
	*/
	processPayment(params = {}) {
		if (this.state.isDonating) {
			return;
		}

		this.setState({ isDonating: true })
		guestPayment(params).then((response = {}) => {
			this.setState({ isDonating: false })

			if (response.code === 'CROSS_BORDER' && response.fundingOpts) {
				const fundingOptions = response.fundingOpts[0];

				// Updating store with funding options and redirecting to review page
				DonateAppActions.updateFundingOptions({ fundingOptions })
				this.setState({ isDonating: false })
				return this.context.router.push('/donate/guest/crossborder');
			} else if (response.error &&
				response.error.auth_state === 'LOGGEDIN') {
				return this.handleMemberFailure();
			} else if (response.confirmation) {
				DonateAppActions.updateConfirmation({ confirmation: response.confirmationData });
				return this.handlePaymentSuccess(response);
			} else {
				return this.handlePaymentFailure(err);
			}
		}).catch((err)=>{
			console.log('processDonation err :: ', err);
			this.setState({ isDonating: false })
			return this.handlePaymentFailure(err);
		})
	},

	/*
	* handlePaymentSuccess
	*/
	handlePaymentSuccess(response) {
		if (response.isOfacPending) {
			this.context.router.push('/donate/guest/pending')
		} else {
			this.context.router.push('/donate/guest/confirmation');
		}
	},

	/*
	* handlePaymentFailure
	*/
	handlePaymentFailure(response) {
		this.context.router.push('/donate/error/payment');
	},

	/*
	* handleMemberFailure
	* Redirect all member failure to donate/member
	* Known case
	* Case 1 :- WSM_PAYER_FUNDING_INSTRUMENTS_UNAVAILABLE
	* Case 2 :- WSM_VALIDATION_ERROR
	*/
	handleMemberFailure() {
		updateDonation(`/donate/member?token=${templateData.token}`);
	},

	/**
	* Should show note when charityNote is enabled and recurring is disabled
	* @return {Boolean} true to show note field
	*/
	shouldShowNote() {
		return templateData.charityNoteEnabled && !this.state.recurringStatus;
	},

	render() {
		const progressiveOnboardingProps = {
			updateReduxStore: this.updateReduxStore,
			modelData: {},
			token: templateData.token,
			setInitialState: this.setInitialState,
			endpoint: `/welcome/donate?country.x=${templateData.country}&locale.x=${templateData.language}_${templateData.country}`
		}
		const errorgeneric = errorMessages.error && errorMessages.error.generic || '';
		const recurringStatus = AppStore.getDonationRecurring() === 'checked';

		return (
			<div className="donate_wrapper">
				<div className="container">
					{this.state.showServiceErrors ?
						<div className="col-xs-12 col-sm-12 col-md-12 service_error_holder">
							{this.state.errorMesages.map(function(message) {
								return <div className="row" key={message.key}>
											<p className="col-xs-1 col-sm-1 col-md-1"><span className="icon icon-small icon-critical-small" aria-hidden="true"></span></p>
											<p className="col-xs-11 col-sm-11 col-md-11"style={{ paddingLeft: '5px', marginTop: '5px' }}>{message.value}</p>
								</div>;
							})}
						</div> : null}
					<GlobalBanner
						logourl={this.state.logourl}/>
					<SubHeader
						donationId={this.state.donationId}
						orgName={this.state.orgName}
						label={this.state.subHeaderLabel}/>
					<form id="guestForm" className="donate_guest_form" noValidate>
						<AmountWrapper
							conversionStatus={this.updateConversionSataus}
							validateDonationAmount={this.validateDonationAmount}
							showValidationError={this.state.showValidationError}
							hideValidationError={this.hideValidationError}
							validationErrorMessage={this.state.validationErrorMessage}
							onFocus={this.handleAmountFocus}
						/>
						<p className="err_update_amount text-center">{errorgeneric}</p>
						{this.state.recurringEnabled &&
							<RecurringCheckBox
								toolTipText={this.state.recurringHelpText}
								label={this.state.recurringLabel}
								status={this.state.recurringStatus}
								handleChange={this.handleRecurringChange}
								hasRecurringHelp={false}
								showNote={true}
							/>
						}
						<LinnerDiv />
						{this.shouldShowNote() ? <Note /> : null}
						{showGuestPPLogInExp ?
							<GuestPPLogIn handleLogIn={this.handleLogIn}/> :
							<GuestPPLogInMini handleLogIn={this.handleLogIn}/>
						}
						<PayCreditOrDebit />

						{!this.state.isProgressive &&
							<div className="donate_guest_form">
								<GuestForm
									recurringStatus={recurringStatus}
									donateDisabled={this.state.donateDisabled}
									validateDonationAmountForUS={this.validateDonationAmount}
								/>
							</div>
						}
					</form>

					{this.state.isProgressive &&
						<div className="donate_onboarding_guest_form">
							{React.createElement(Progressiveonboarding.default, progressiveOnboardingProps)}
							<GuestSubmitButton
								// amount={this.state.formatedAmount}
								labels={allGuestMessages.guestLabels}
								isRecurring={false}
								// disabled={this.props.donateDisabled}
								handleClick={this.triggerAccountCreation}
								// passwordFieldsOpen={this.state.passwordFieldsOpen}
							/>
						</div>
					}
				</div>
			</div>
		)
	}
})



// WEBPACK FOOTER //
// ./pages/guest/guest.js